import { CADIE_BASE_URL, CPNA_BASE_URL } from "../../props";
import { useGet, doPostWithoutAuth, doFetch } from "../../common/fetchServices";
import { last, pickBy, pipe, split } from "ramda";
import { notBlank } from "../../util/ext";
import querystring from "querystring";
import { formatDateString } from "../../util/stringFormat";
import { useQuery } from "@tanstack/react-query";

export const useDiscoverySearch = searchState => {
  const params = pickBy((val, _key) => notBlank(val), {
    startDate: formatDateString(searchState.startDate),
    endDate: formatDateString(searchState.endDate),
    filename: searchState.filename,
    status: searchState.status,
  });

  const queryParams = querystring.encode(params);
  const url = `${CADIE_BASE_URL}/log-manager/api/events?${queryParams}`;
  return useGet(["event-search", { url }], url);
};

export const useGetJobChunks = jobId => {
  const url = `${CADIE_BASE_URL}/log-manager/api/events/job/${jobId}/chunks`;
  return useGet(["job-chunks", { url }], url);
};

export const useGetJobDetail = jobId => {
  const url = `${CADIE_BASE_URL}/log-manager/api/jobs/${jobId}`;
  return useGet(["job-detail", { url }], url);
};

export const useGetChunkDetail = (jobId, chunkId) => {
  const url = `${CADIE_BASE_URL}/log-manager/api/jobs/${jobId}/chunks/${chunkId}`;
  return useGet(["chunk-detail", { url }], url);
};

export const useContentProvider = (contentProviderId, options = {}) => {
  const { enabled = true } = options;

  const url = `${CADIE_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}`;
  return useGet(["content-provider", { url }], url, enabled);
};

export const useContentProviderEndpoint = (
  contentProviderId,
  contentProviderEndpointId,
  options = {},
) => {
  const { enabled = true } = options;
  const url = `${CADIE_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}/endpoints/${contentProviderEndpointId}`;
  return useGet(["content-provider-endpoint", { url }], url, enabled);
};

export const useContentProviders = () => {
  const url = `${CPNA_BASE_URL}/rip/content-provider`;
  return useGet(["content-providers"], url);
};

export const useContentProviderEndpoints = () => {
  const url = `${CPNA_BASE_URL}/rip/content-provider-endpoint`;
  return useGet(["content-provider-endpoints"], url);
};

export const getDownloadUrl = async location => {
  const url = `${CADIE_BASE_URL}/log-manager/api/files/s3/signed-url`;
  const encodedLocation = encodeS3Uri(location);
  const downloadUrl = await doPostWithoutAuth(url, {
    location: encodedLocation,
  });
  console.log(downloadUrl);
  return downloadUrl.url;
};

export const useErrorReport = location => {
  return useQuery({
    queryKey: ["error-report", location],
    queryFn: async () => {
      const signedUrl = await getDownloadUrl(location);
      return doFetch(signedUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    enabled: !!location,
  });
};

const encodeRfc3986 = s =>
  encodeURIComponent(s).replace(
    /[!'()*]/g,
    c => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
  );

const encodeS3Uri = uri => {
  const match = uri.match(/^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)(.*)$/);
  if (!match) {
    // no scheme, just encode normally
    return uri.split("/").map(encodeRfc3986).join("/");
  }

  const [, scheme, rest] = match;
  return scheme + rest.split("/").map(encodeRfc3986).join("/");
};

export const generateFilename = pipe(split("/"), last);
